// extracted by mini-css-extract-plugin
export default {"user-select-text":"productionSheetsTable_user-select-text__wwThl"};